import { inject, Injectable } from "@angular/core";
import { SessionStorageService } from "./session-storage.service";
import { Store, select } from "@ngrx/store";
import { select_MOUI_User } from "../state-management/mobi-office-ui.selector";

@Injectable({
  providedIn: "root",
})
export class RightsService {
  private readonly sessionStorage = inject(SessionStorageService);
  private readonly store = inject(Store);

  constructor() {}

  get rightsControl(): rightsControl {
    const rights: rightsControl = {
      canEdit: false,
      canDelete: false,
      canAdd: false,
      canView: false,
      canApprove: false,
    };
    rights.canEdit = !!+(this.sessionStorage.getItem("canEdit") || "0");
    rights.canDelete = !!+(this.sessionStorage.getItem("canDelete") || "0");
    rights.canAdd = !!+(this.sessionStorage.getItem("canAdd") || "0");
    rights.canView = !!+(this.sessionStorage.getItem("canView") || "0");
    rights.canApprove = !!+(this.sessionStorage.getItem("canApprove") || "0");
    return rights;
  }

  //#region Rights Control

  getPageRightsByMenuID(MenuID: number): rightsControl {
    const rights: rightsControl = {
      canAdd: false,
      canDelete: false,
      canEdit: false,
      canView: false,
      canApprove: false,
    };
    this.store.pipe(select(select_MOUI_User)).subscribe((res: any) => {
      const Menus = res?.UserInfo?.Menus || [];
      if (Menus?.length) {
        const currentMenu = Menus?.find((el: any) => +el.MenuID === +MenuID);
        if (!currentMenu) return;
        rights.canAdd = !!currentMenu.canAdd;
        rights.canDelete = !!currentMenu.canDelete;
        rights.canEdit = !!currentMenu.canEdit;
        rights.canView = !!currentMenu.canView;
        rights.canApprove = !!currentMenu.canApprove;
      }
    });
    return rights;
  }

  getPageRightsByAOrder(AOrder: number): rightsControl {
    const rights: rightsControl = {
      canAdd: false,
      canDelete: false,
      canEdit: false,
      canView: false,
      canApprove: false,
    };
    this.store.pipe(select(select_MOUI_User)).subscribe((res: any) => {
      const Menus = res?.UserInfo?.Menus || [];
      if (Menus?.length) {
        const currentMenu = Menus?.find((el: any) => +el.AOrder === +AOrder);
        if (!currentMenu) return;
        rights.canAdd = !!currentMenu.canAdd;
        rights.canDelete = !!currentMenu.canDelete;
        rights.canEdit = !!currentMenu.canEdit;
        rights.canView = !!currentMenu.canView;
        rights.canApprove = !!currentMenu.canApprove;
      }
    });
    return rights;
  }

  //#endregion

  //#region Set Rights Session

  setRightsSessionStorage(currentUrl: string) {
    this.store.pipe(select(select_MOUI_User)).subscribe((userRes: any) => {
      const resetRights = () => {
        this.sessionStorage.setItem("canAdd", "0");
        this.sessionStorage.setItem("canDelete", "0");
        this.sessionStorage.setItem("canEdit", "0");
        this.sessionStorage.setItem("canView", "0");
        this.sessionStorage.setItem("canApprove", "0");
      };

      const setRights = (menu: any) => {
        this.sessionStorage.setItem("canAdd", menu?.canAdd === true ? "1" : "0");
        this.sessionStorage.setItem("canDelete", menu?.canDelete === true ? "1" : "0");
        this.sessionStorage.setItem("canEdit", menu?.canEdit === true ? "1" : "0");
        this.sessionStorage.setItem("canView", menu?.canView === true ? "1" : "0");
        this.sessionStorage.setItem("canApprove", menu?.canApprove === true ? "1" : "0");
      };

      const actualUrl = currentUrl?.split("?")[0];
      const Menus = userRes?.UserInfo?.Menus || [];

      if (!Menus?.length) {
        resetRights();
        return;
      }

      // Use find instead of findIndex to get the first matching menu
      const findMatchedMenu = Menus?.find((el: any) => el.URL === actualUrl);

      if (!findMatchedMenu) {
        // Handle the case when no matching menu is found
        resetRights();
        return;
      }

      setRights(findMatchedMenu);
      console.log(findMatchedMenu);
      return findMatchedMenu;
    });
  }

  //#endregion
}

interface rightsControl {
  canEdit: boolean;
  canDelete: boolean;
  canAdd: boolean;
  canView: boolean;
  canApprove: boolean;
}
